import ApiClient from "../helpers/ApiClient";

const logar = (data) =>
  ApiClient.backendClient.post(`login/logar`, data, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const logarEmpresa = (data) =>
  ApiClient.backendClient.post(`Gerenciador/empresa`, data, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const recuperarSenha = (data) =>
  ApiClient.backendClient.post(`UserRecovery/forgotMyPassword`, data, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const resetarSenha = (data) =>
  ApiClient.backendClient.post(`UserRecovery/new_password`, data, {
    headers: {
      Token: process.env.REACT_APP_TOKEN,
    },
  });

const AuthApiClient = { logar, logarEmpresa, recuperarSenha, resetarSenha };
export default AuthApiClient;
